import { Plus, Trash2 } from "lucide-react";
import useSettings from "./useSettings";
import { SettingsHeader, Section, Field, Loading, MultiLangField } from "./_shared";

export default function ContactSettingsAdmin() {
  const { settings, set, save, saving, saved } = useSettings();
  if (!settings) return <Loading />;

  const updatePartner = (i, k, v) => {
    const list = [...(settings.partner_logos || [])];
    list[i] = { ...list[i], [k]: v };
    set("partner_logos", list);
  };
  const addPartner = () => set("partner_logos", [...(settings.partner_logos || []), { name: "", logo_url: "", url: "" }]);
  const removePartner = (i) => set("partner_logos", settings.partner_logos.filter((_, idx) => idx !== i));

  return (
    <div data-testid="cms-settings-contact">
      <SettingsHeader
        title="Contacto y datos del sitio"
        description="Información de contacto, redes sociales y logos institucionales del footer."
        onSave={save}
        saving={saving}
        saved={saved}
      />

      <div className="space-y-6">
        <Section title="Contacto">
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Dirección" value={settings.contact_address} onChange={(v) => set("contact_address", v)} />
            <Field label="Teléfono" value={settings.contact_phone} onChange={(v) => set("contact_phone", v)} />
            <Field label="Email" value={settings.contact_email} onChange={(v) => set("contact_email", v)} />
            <Field label="Map embed URL" value={settings.map_embed} onChange={(v) => set("map_embed", v)} />
            <div className="md:col-span-2">
              <MultiLangField label="Horario" prefix="contact_hours" settings={settings} set={set} />
            </div>
          </div>
        </Section>

        <Section title="Redes sociales">
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Facebook" value={settings.facebook} onChange={(v) => set("facebook", v)} />
            <Field label="LinkedIn" value={settings.linkedin} onChange={(v) => set("linkedin", v)} />
            <Field label="Instagram" value={settings.instagram} onChange={(v) => set("instagram", v)} />
            <Field label="Twitter" value={settings.twitter} onChange={(v) => set("twitter", v)} />
            <Field label="YouTube" value={settings.youtube} onChange={(v) => set("youtube", v)} />
          </div>
        </Section>

        <Section title="Logos del footer (con el apoyo y reconocimiento de)">
          <div className="space-y-3">
            {(settings.partner_logos || []).map((p, i) => (
              <div key={`${p.logo_url || p.name || "partner"}-${i}`} className="grid md:grid-cols-12 gap-3 items-center" data-testid={`partner-row-${i}`}>
                <input value={p.name} onChange={(e) => updatePartner(i, "name", e.target.value)} placeholder="Nombre" className="md:col-span-3 px-3 py-2 border border-gray-200 text-sm" />
                <input value={p.logo_url} onChange={(e) => updatePartner(i, "logo_url", e.target.value)} placeholder="URL del logo" className="md:col-span-5 px-3 py-2 border border-gray-200 text-sm" />
                <input value={p.url || ""} onChange={(e) => updatePartner(i, "url", e.target.value)} placeholder="URL destino (opcional)" className="md:col-span-3 px-3 py-2 border border-gray-200 text-sm" />
                {p.logo_url && <img src={p.logo_url} alt="" className="md:col-span-1 h-9 object-contain" />}
                <button onClick={() => removePartner(i)} className="md:col-span-12 md:hidden p-2 text-red-600">Eliminar</button>
                <button onClick={() => removePartner(i)} className="hidden md:inline-flex p-2 text-gray-400 hover:text-red-600">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            ))}
            <button onClick={addPartner} data-testid="partner-add" className="text-sm text-[#C8102E] hover:underline flex items-center gap-1.5">
              <Plus className="w-4 h-4" /> Añadir logo
            </button>
          </div>
        </Section>
      </div>
    </div>
  );
}
